var TabApprovalsEquipmentsCustomFieldsComponent = /** @class */ (function () {
    function TabApprovalsEquipmentsCustomFieldsComponent(approval) {
        this.approval = approval;
    }
    return TabApprovalsEquipmentsCustomFieldsComponent;
}());
export { TabApprovalsEquipmentsCustomFieldsComponent };
